<div class="p-4 pb-3 d-flex flex-row justify-content-between">
    <div>
        <h6 class="fs-5 mb-0">All Contacts</h6>
        <small
            >Contacts in System: <b>{{ this.params.totalRecords }}</b></small
        >
    </div>
    <a
        class="btn btn-styled btn-sm align-self-start"
        (click)="addEditLead()"
        [ngClass]="{ disabled: params.prospect === 0 }">
        <svg-icon src="assets/images/call/btn-plus-sign.svg"></svg-icon>
        New Lead</a
    >
</div>
<div class="d-flex justify-content-start px-4 pb-4">
    <input
        type="search"
        placeholder="Search by Phone Number or Customer Name"
        class="search-text-input me-3"
        style="min-width: 394px"
        [ngClass]="{ loading: isLoading }"
        [(ngModel)]="params.name"
        (keyup)="updateProspectsDebounce({ name: params.name })"
        (keyup.enter)="updateProspects({ name: params.name })" />

    <app-switcher
        theme="grey"
        [switchList]="customerOrProspectItems"
        (switched)="updateProspects({ prospect: $event.id === 1 ? undefined : 0 })"></app-switcher>
    <app-switcher
        theme="grey"
        [switchList]="favoriteOrNot"
        (switched)="updateProspects({ favorite: $event.id === 1 ? 0 : 1 })"></app-switcher>

    <ng-select
        class="mx-3"
        style="min-width: 218px"
        placeholder="Customer Type"
        [clearable]="false"
        [searchable]="false"
        (change)="updateProspects({ accountType: $event })">
        <ng-option
            [value]="accType"
            *ngFor="let accType of UserAccountTypeEnum">
            {{ accType | capitalize }}
        </ng-option>
    </ng-select>

    <div class="form-group date-fld me-3">
        <input
            type="text"
            class="form-control"
            placeholder="dd/mm/yyyy"
            #drp="bsDatepicker"
            bsDatepicker
            [bsConfig]="bsConfig"
            (bsValueChange)="updateProspects({ createdAt: $event.toString() })" />
        <button type="submit">
            <svg-icon
                (click)="drp.toggle()"
                src="assets/images/inputs/date_input_calendar.svg"></svg-icon>
        </button>
    </div>
</div>

<div class="w-100 d-flex justify-content-center pb-4">
    <app-inline-spinner [spinnerConfig]="{ ldsLoader: true, showSpinner: isLoading }"></app-inline-spinner>
    <div
        class="no-results"
        *ngIf="!prospects.length && !isLoading">
        <p>No records found</p>
    </div>
</div>

<div class="w-100 flex-grow-1 overflow-auto">
    <table
        class="table table-borderless table-hover align-middle"
        *ngIf="prospects.length && !isLoading">
        <thead class="thead-white">
            <tr>
                <th class="fs-sm fw-normal text-nowrap ps-4">NAME</th>
                <th class="fs-sm fw-normal text-nowrap ps-4">PHONE</th>
                <th class="fs-sm fw-normal text-nowrap ps-4">STATUS</th>
                <th class="fs-sm fw-normal text-nowrap ps-4">ROLE</th>
                <th
                    class="fs-sm fw-normal text-nowrap ps-4 sortable"
                    [ngClass]="{ asc: params.ascOrDesc === 'ASC', desc: params.ascOrDesc === 'DESC' }"
                    (click)="updateProspects({ ascOrDesc: params.ascOrDesc === 'ASC' ? 'DESC' : 'ASC' })">
                    DATE CREATED
                </th>
            </tr>
        </thead>

        <tr
            *ngFor="let prospect of prospects"
            class="call-log-row">
            <td class="fs-sm fw-normal text-nowrap ps-4">
                {{ prospect.contact.firstname }} {{ prospect.contact.surname }}
            </td>
            <td class="fs-sm fw-normal text-nowrap ps-4">{{ prospect.contact.mobile | formatPhone }}</td>
            <td class="fs-sm fw-normal text-nowrap ps-4">
                <span class="call-tag cold --xxl" *ngIf="prospect.prospect !== 0">Lead</span>
            </td>
            <td class="fs-sm fw-normal text-nowrap ps-4">{{ accountTypeName(prospect.accountType) }}</td>
            <td class="fs-sm fw-normal text-nowrap ps-4">{{ prospect.createdAt | date : 'dd MMM yyyy HH:mm' }}</td>

            <td class="d-flex">
                <svg-icon
                    class="hover"
                    src="assets/images/call/phone-handset.svg"
                    (click)="makeACallProspect(prospect)"></svg-icon>
                <div
                    appDropdown
                    class="dropdown ys-dropdown-menu">
                    <span
                        class="hover"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <svg-icon src="assets/images/call/icon-menu-action.svg"></svg-icon>
                    </span>
                    <div class="dropdown-menu dropdown-menu-end shadow-sm p-0 g-0">
                        <span
                            class="dropdown-item text-primary py-2 heart"
                            [ngClass]="{ '-broken': favoriteOrContact }"
                            (click)="editProspectFav(prospect)">
                            {{ favoriteOrContact ? 'Not anymore' : 'Make favorite' }}
                        </span>
                        <div class="dropdown-divider m-0 mx-3"></div>
                        <span
                            class="dropdown-item text-primary py-2"
                            [ngClass]="{ disabled: params.prospect === 0 }"
                            (click)="addEditLead(prospect)">
                            Edit contact
                        </span>
                    </div>
                </div>
            </td>
        </tr>
    </table>
</div>

<div class="w-100 p-4">
    <app-pagination [params]="params" (update)="updateProspects()"></app-pagination>
</div>
